import { Row, Col, Form, Input, Select, Radio } from "antd";
import { HeaderUser } from "../../components/HeaderUser";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";

const Settings = () => {
  const navigate = useNavigate();

  return (
    <>
      <HeaderUser />
      <div style={{ marginTop: "2vh" }}>
        <Row>
          <Col
            span={24}
            className="roi--settings-title"
            style={{ marginTop: "1.5vh", textAlign: "center" }}
          >
            <img
              src="/images/icons/settings.png"
              style={{ marginLeft: "2vh", width: "40px" }}
            />
            <span style={{ marginLeft: "1vh" }}>
              <FormattedMessage id="settings" />
            </span>
          </Col>
        </Row>
      </div>
      <div style={{ marginTop: "2vh" }}>
        <Row gutter={24} style={{ marginRight: "1vh" }}>
          <span
            className="roi--section-title"
            style={{ marginLeft: "2vh" }}
          ></span>
        </Row>
      </div>
      <div style={{ marginTop: "2vh" }}>
        <Row
          gutter={24}
          onClick={() => navigate("/general")}
          className="roi--background-section roi--cursor"
          style={{ marginRight: "1vh" }}
        >
          <Col
            span={20}
            className="roi--header-content "
            style={{ marginTop: "1.5vh" }}
          >
            <span style={{ marginLeft: "1vh" }}>
              <FormattedMessage id="general" />
            </span>
          </Col>
          <Col
            span={4}
            style={{
              margin: "auto",
              padding: "10px",
              textAlign: "right",
              alignItems: "center",
            }}
          >
            <img
              style={{ width: "1.5vh" }}
              src="/images/icons/next.svg"
              className="roi--cursor"
            />
          </Col>
        </Row>
      </div>{" "}
      <div style={{ marginTop: "2vh" }}>
        <Row
          gutter={24}
          onClick={() => navigate("/history")}
          className="roi--background-section roi--cursor"
          style={{ marginRight: "1vh" }}
        >
          <Col
            span={20}
            className="roi--header-content "
            style={{ marginTop: "1.5vh" }}
          >
            <span style={{ marginLeft: "1vh" }}>
              <FormattedMessage id="history" />
            </span>
          </Col>
          <Col
            span={4}
            style={{
              margin: "auto",
              padding: "10px",
              textAlign: "right",
              alignItems: "center",
            }}
          >
            <img
              style={{ width: "1.5vh" }}
              src="/images/icons/next.svg"
              className="roi--cursor"
            />
          </Col>
        </Row>
      </div>{" "}
      <div style={{ marginTop: "2vh" }}>
        <a href="https://airtable.com/shrKprahZtT6XM8gc" target="_blank">
          <Row
            gutter={24}
            className="roi--background-section"
            style={{ marginRight: "1vh" }}
          >
            <Col
              span={20}
              className="roi--header-content"
              style={{ marginTop: "1.5vh" }}
            >
              <span style={{ marginLeft: "1vh" }}>
                <FormattedMessage id="feedback" />
              </span>
            </Col>
            <Col
              span={4}
              style={{
                margin: "auto",
                padding: "10px",
                textAlign: "right",
                alignItems: "center",
              }}
            >
              <img
                style={{ width: "1.5vh" }}
                src="/images/icons/next.svg"
                className="roi--cursor"
              />
            </Col>
          </Row>
        </a>
      </div>{" "}
      {/* <div style={{ marginTop: "2vh" }}>
        <Row
          gutter={24}
          className="roi--background-section roi--cursor"
          style={{ marginRight: "1vh" }}
          onClick={() => navigate("/complain")}
        >
          <Col
            span={20}
            className="roi--header-content"
            style={{ marginTop: "1.5vh" }}
          >
            <span style={{ marginLeft: "1vh" }}>
              <FormattedMessage id="complain" />
            </span>
          </Col>
          <Col
            span={4}
            style={{
              margin: "auto",
              padding: "10px",
              textAlign: "right",
              alignItems: "center",
            }}
          >
            <img
              style={{ width: "1.5vh" }}
              src="/images/icons/next.svg"
              className="roi--cursor"
            />
          </Col>
        </Row>
      </div> */}
    </>
  );
};
export default Settings;
